import React from 'react';
import { IoChevronDown, IoSearch } from 'react-icons/io5';
import './FiltrosIniciativas.scss';

interface FiltrosIniciativasProps {
  categoriaSelecionada: string;
  onCategoriaChange: (categoria: string) => void;
  termoBusca: string;
  onBuscaChange: (termo: string) => void;
  onBuscar: () => void;
}

export const FiltrosIniciativas: React.FC<FiltrosIniciativasProps> = ({
  categoriaSelecionada,
  onCategoriaChange,
  termoBusca,
  onBuscaChange,
  onBuscar
}) => {
  const categorias = [
    { id: '', label: 'Todas as categorias' },
    { id: 'JOGA_JUNTO', label: 'Joga Junto' },
    { id: 'CONEXAO', label: 'Prêmio Conexão' },
    // ELBB será adicionado dinamicamente na página ELBB se necessário
  ];

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onBuscar();
    }
  };

  return (
    <div className="filtros-iniciativas">
      <div className="filtros-iniciativas__container">
        <div className="filtros-iniciativas__dropdown">
          <label htmlFor="categoria-select" className="filtros-iniciativas__label">
          </label>
          <div className="filtros-iniciativas__select-wrapper">
            <select
              id="categoria-select"
              className="filtros-iniciativas__select"
              value={categoriaSelecionada}
              onChange={(e) => onCategoriaChange(e.target.value)}
            >
              {categorias.map((categoria) => (
                <option key={categoria.id} value={categoria.id}>
                  {categoria.label}
                </option>
              ))}
            </select>
            <IoChevronDown className="filtros-iniciativas__select-icon" />
          </div>
        </div>

        <div className="filtros-iniciativas__busca">
          <div className="filtros-iniciativas__busca-wrapper">
            <IoSearch className="filtros-iniciativas__busca-icon" size={20} />
            <input
              id="busca-input"
              type="text"
              className="filtros-iniciativas__busca-input"
              placeholder="O que você procura?"
              value={termoBusca}
              onChange={(e) => onBuscaChange(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
